// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Blog Cards Layout*/
/* Change colors in this file to style to your needs on a global level. 
Certain colors are used for different and multiply types of elements. 
For greater control over colors visit each components .scss file. */
.square {
  width: 440px;
  height: 430px;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 20px 50px #d9dbdf;
  transition: all 0.3s ease;
  margin-top: 30px;
}

.square:hover {
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

.blog-header-text {
  font-size: 56px;
  font-weight: 400;
}

.blog-subtitle {
  text-transform: uppercase;
}

.blog-main-div > * {
  flex: 1 1;
  margin-bottom: 30px;
}

.blog-main-div {
  display: flex;
}

.blog-image-div > img {
  max-width: 100%;
  height: auto;
}

.blog-text-div {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  grid-gap: 32px;
  gap: 32px;
}

.subTitle {
  color: #868e96;
}

/* Media Query */
@media (max-width: 1380px) {
  .blog-header-text {
    font-size: 40px;
  }
}
@media (max-width: 768px) {
  .blog-header-text {
    font-size: 30px;
    text-align: center;
  }
  .blog-subtitle {
    font-size: 16px;
    line-height: normal;
    text-align: center;
  }
}
@media screen and (max-width: 480px) and (min-width: 300px) {
  .blog-text-div {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }
}`, "",{"version":3,"sources":["webpack://./src/containers/blogs/Blog.scss","webpack://./src/_globalColor.scss"],"names":[],"mappings":"AAAA,oBAAA;ACAA;;mEAAA;ADGA;EACE,YAAA;EACA,aAAA;EACA,mBCYc;EDXd,kBAAA;EACA,iCAAA;EAGA,yBAAA;EACA,gBAAA;AAEF;;AACA;EACE,0CAAA;AAEF;;AACA;EACE,eAAA;EACA,gBAAA;AAEF;;AACA;EACE,yBAAA;AAEF;;AAAA;EACE,SAAA;EACA,mBAAA;AAGF;;AADA;EACE,aAAA;AAIF;;AAFA;EACE,eAAA;EACA,YAAA;AAKF;;AAHA;EACE,aAAA;EACA,4DAAA;EACA,cAAA;EAAA,SAAA;AAMF;;AAJA;EACE,cChCS;ADuCX;;AAJA,gBAAA;AACA;EACE;IACE,eAAA;EAOF;AACF;AALA;EACE;IACE,eAAA;IACA,kBAAA;EAOF;EALA;IACE,eAAA;IACA,mBAAA;IACA,kBAAA;EAOF;AACF;AAJA;EACE;IACE,4DAAA;EAMF;AACF","sourcesContent":["/*Blog Cards Layout*/\n@import \"../../_globalColor\";\n\n.square {\n  width: 440px;\n  height: 430px;\n  background: $textColorDark;\n  border-radius: 4px;\n  box-shadow: 0px 20px 50px $darkBoxShadow;\n  -webkit-transition: all 0.3s ease;\n  -o-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n  margin-top: 30px;\n}\n\n.square:hover {\n  box-shadow: 0 20px 40px $lightBoxShadow;\n}\n\n.blog-header-text {\n  font-size: 56px;\n  font-weight: 400;\n}\n\n.blog-subtitle {\n  text-transform: uppercase;\n}\n.blog-main-div > * {\n  flex: 1;\n  margin-bottom: 30px;\n}\n.blog-main-div {\n  display: flex;\n}\n.blog-image-div > img {\n  max-width: 100%;\n  height: auto;\n}\n.blog-text-div {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));\n  gap: 32px;\n}\n.subTitle {\n  color: $subTitle;\n}\n\n/* Media Query */\n@media (max-width: 1380px) {\n  .blog-header-text {\n    font-size: 40px;\n  }\n}\n@media (max-width: 768px) {\n  .blog-header-text {\n    font-size: 30px;\n    text-align: center;\n  }\n  .blog-subtitle {\n    font-size: 16px;\n    line-height: normal;\n    text-align: center;\n  }\n}\n\n@media screen and (max-width: 480px) and (min-width: 300px) {\n  .blog-text-div {\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  }\n}\n","/* Change colors in this file to style to your needs on a global level. \nCertain colors are used for different and multiply types of elements. \nFor greater control over colors visit each components .scss file. */\n\n// button colors\n$buttonColor: #55198b;\n$buttonHover: #8c43ce;\n$topButtonHover: #000;\n\n// text colors light theme\n$titleColor: #000000;\n$textColor: #000000;\n$subTitle: #868e96;\n$cardSubtitle: #666666;\n$talkCardSubTitle: #7f8287;\n$blogCardTitleColor: #262626;\n\n// text color dark theme\n$textColorDark: #ffffff;\n\n// toggle switch colors\n$toggleCheck: #2196f3;\n$toggleSwitchSliderBG: #ccc;\n\n// githubRepo specific colors\n$githubRepoCardLanguageColorBG: #0000ff;\n$githubRepoCardColor: rgb(88, 96, 105);\n$githubRepoCardRepoCardStatsColor: rgb(106, 115, 125);\n$githubRepoCardRepoNameColor: rgb(36, 41, 46);\n$githubProfileCardLocationTS: #ffebcd;\n$githubProfileCardBorder: #6c63ff;\n\n// light background colors\n$lightBackground1: #fff;\n$lightBackground2: rgb(255, 255, 255);\n$lightBackground3: #f5f2f4;\n$blogCardContainerColor: #586069;\n// dark background colors\n$darkBackground: #171c28;\n\n// light theme box shadows\n$lightBoxShadowDark: rgba(0, 0, 0, 0.2);\n$lightBoxShadow: rgba(0, 0, 0, 0.1);\n$lightBoxShadowDarker: rgba(0, 0, 0, 0.3);\n\n// dark theme box shadows\n$darkBoxShadow: #d9dbdf;\n$darkBoxShadow2: #ffffff;\n\n// linear gradients\n$experienceCardBlurredDivLG: linear-gradient(\n  rgba(0, 0, 0, 0.4),\n  rgba(0, 0, 0, 0.2)\n);\n$experienceCardBannerLG: linear-gradient(\n  rgba(0, 0, 0, 0.7),\n  rgba(0, 0, 0, 0.5)\n);\n\n// borders\n$progressBarBackground: rgb(243, 239, 239);\n$lightBorder1: rgba(211, 211, 211, 0.397);\n$educationCardBorder: #a9a7f9;\n\n// hovers\n$achievementCertificateCardHoverDark: rgba(255, 255, 255, 0.2);\n$blogCardHoverSmallColor: rgba(255, 255, 255, 0.8);\n$headerHoverBG: #f4f4f4;\n$contactDetailHoverTS: #b5b5b5;\n\n// misc backgrounds\n$progressBarSpanBG: #aaa5ff;\n$iconBackground: #333;\n$appHeaderBG: #282c34;\n\n// misc colors\n$skillsColor: #645beb;\n$appLink: #09d3ac;\n\n// social media icons\n$faceBook: #3b5998;\n$linkedin: #0e76a8;\n$github: #333;\n$gitlab: #fca326;\n$google: #ea4335;\n$twitter: #1da1f2;\n$medium: #000;\n$stackoverflow: #f48024;\n$instagram: #c13584;\n$kaggle: #20beff;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
